import { InsightsFiltersOptionsQuery } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

const getHistoricalGenders = (filtersOptionsData: InsightsFiltersOptionsQuery) => {
  const insightsFilterData = filtersOptionsData.reports.insightsFiltersConnection.nodes.find(
    (filterData) => filterData.filterType === 'genders'
  )

  return insightsFilterData?.values ?? []
}

export const useGenderOptions = (filtersOptionsData: InsightsFiltersOptionsQuery) => {
  const options = useUnsafeMemo(() => {
    const historicalGenders = getHistoricalGenders(filtersOptionsData)

    const currentGenders = filtersOptionsData.companies.gendersConnection.nodes
    const currentGendersNames = new Set(currentGenders.map((gender) => gender.name))

    const removedGenders = historicalGenders.filter(
      (historicalGender) => !currentGendersNames.has(historicalGender)
    )

    return [
      ...orderBy(currentGenders).map((gender) => ({
        label: gender.translatedName,
        value: gender.name,
      })),
      ...orderBy(removedGenders).map((gender) => ({
        label: i18n.t('insights.filters.types.gender.deprecated_label', { gender }),
        value: gender,
      })),
    ]
  }, [filtersOptionsData])

  return options
}
